// rootReducer.js
import { combineReducers } from 'redux';
import selectedStateReducer from './selectedStateReducer';
// import other reducers if you have them

const rootReducer = combineReducers({
  selectedState: selectedStateReducer,
  
  // other reducers go here
});

export default rootReducer;
